import { EnvironmentOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { Header } from "antd/lib/layout/layout";
import { User } from "oidc-react";
import { useLayoutEffect, useRef, useState } from 'react';
import styles from './headerComponent.module.less';
import { AsyncButton } from "digimuth-components/dist";
import { ApplicationUserRole } from "../../../api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RoutingPaths } from "../../routing/routingContainer";
import useCurrentUserRoles from "../../../hooks/useCurrentUserRoles";
import PiknikLogo from "../../../assets/piknikLogo.svg";
import { ReactComponent as Navigation } from "../../../assets/navigation.svg";
import MapSider from '../mapSider/mapSider';

interface HeaderComponentProps {
    onLogoutPressed: () => Promise<any>,
    onLoginPressed: () => Promise<any>,
    userData?: User | null;
}

export default function HeaderComponent(props: HeaderComponentProps) {
    const headerRef = useRef<HTMLDivElement | null>(null)
    const userRoles = useCurrentUserRoles();
    const navigate = useNavigate();
    const location = useLocation();
    const [siderCollapsed, setSiderCollapsed] = useState(true);
    const searchParams = new URLSearchParams(location.search);
    const shouldCompactLogoOnMobile = !location.pathname.startsWith("/cms")
        && (
            searchParams.get("nav") === "1"
            || searchParams.get("activeNav") === "1"
            || !!searchParams.get("stand")
        );

    const onManagementSystemClick = () => {
        navigate(RoutingPaths.mainPage.route);
    }

    const onHomeClick = () => {
        window.location.href = RoutingPaths.homePage.route;
    }

    useLayoutEffect(() => {
        const target = headerRef.current
        if (!target) return
        const disablePinchZoom = (e: any) => {
            if (e.touches.length > 1) {
                e.preventDefault()
            }
        }
        target.addEventListener("touchmove", disablePinchZoom, { passive: false })
        return () => {
            target.removeEventListener("touchmove", disablePinchZoom)
        }
    }, [])

    if (props.userData) {
        return <>
            <Header className={styles.exHeader} ref={headerRef}>
                <div className={styles.headerItemsWrapper}>
                    <CnkLogo compactMobile={shouldCompactLogoOnMobile} />
                    <div className={styles.userNameWrapper}>
                        {(userRoles?.includes(ApplicationUserRole.Admin) && !location.pathname.startsWith("/cms")) &&
                            <Button icon={<SettingOutlined />} onClick={onManagementSystemClick}>
                                Panel zarządzania
                            </Button>
                        }

                        {location.pathname.startsWith("/cms") ? <>
                            <Button icon={<EnvironmentOutlined />} onClick={onHomeClick}>
                                Mapa Pikniku
                            </Button>
                            <span>{props.userData.profile.email}</span>
                            <AsyncButton type="text" onClick={props.onLogoutPressed} icon={<LogoutOutlined />}>
                                Wyloguj
                            </AsyncButton>
                        </> : null}
                    </div>
                    {siderCollapsed && <div className={styles.switch}>
                        <Button type="text" icon={<Navigation />} onClick={() => setSiderCollapsed(false)} />
                    </div>}
                </div>
            </Header>
            {!location.pathname.startsWith("/cms") &&
                <MapSider siderCollapsed={siderCollapsed} setSiderCollapsed={setSiderCollapsed} />}
        </>;
    }

    return <>
        <Header className={styles.exHeader} ref={headerRef}>
            <Row>
                <Col xs={22}>
                    <CnkLogo compactMobile={shouldCompactLogoOnMobile} />
                </Col>
                <Col xs={2} className={styles.switch}>
                    {siderCollapsed &&
                        <Button type="text" icon={<Navigation />} onClick={() => setSiderCollapsed(false)} />}
                </Col>
            </Row>
        </Header>
        <MapSider siderCollapsed={siderCollapsed} setSiderCollapsed={setSiderCollapsed} />
    </>;
}

export function CnkLogo(props: { compactMobile?: boolean, onClick?: () => void }) {
    return <Link to={"/"} onClick={props.onClick}>
        <div className={`${styles.logoWrapper} ${props.compactMobile ? styles.logoWrapperCompactMobile : ""}`}>
            <img className={styles.logo} src={PiknikLogo} alt={"29. Piknik Naukowy"} />
        </div>
    </Link>
}
